import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
export default function ProductsHero() {
  return <section data-section-id="253385" id="roof-replacement-hero" className="relative w-full min-h-[60vh] md:min-h-[70vh] flex items-center justify-center bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/modern_roof_replacement.png')] bg-cover bg-center bg-no-repeat bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-primary/70 backdrop-blur-[2px]" aria-hidden="true" />

      {}
      <div className="relative z-10 container mx-auto px-4 py-16 md:py-24 flex flex-col items-center text-center gap-6">
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm text-primary-foreground/80 mb-2">
          <Link to="/ServicesPage" className="hover:text-secondary transition-colors">Services</Link>
          <ChevronRight className="size-4 opacity-50" />
          <Link to="/RoofReplacementPage" className="text-secondary font-medium">Roof Replacement</Link>
        </nav>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground font-default max-w-4xl tracking-tight">
          Expert Roof Replacement Services for Maryland & Northern Virginia Homes
        </h1>

        <div className="flex flex-col items-center gap-3">
          <div className="flex flex-wrap justify-center items-center gap-2 text-xs md:text-sm text-primary-foreground/90 font-medium uppercase tracking-wider">
            <span className="opacity-70">Serving:</span>
            <Link to="/ServiceAreasPage" className="hover:text-secondary transition-colors">Montgomery County</Link>
            <span className="opacity-40">|</span>
            <Link to="/ServiceAreasPage" className="hover:text-secondary transition-colors">Howard County</Link>
            <span className="opacity-40">|</span>
            <Link to="/ServiceAreasPage" className="hover:text-secondary transition-colors">Frederick County</Link>
            <span className="opacity-40">|</span>
            <Link to="/ServiceAreasPage" className="hover:text-secondary transition-colors">Northern Virginia</Link>
            <span className="opacity-40">|</span>
            <Link to="/ServiceAreasPage" className="text-secondary hover:underline">View All Service Areas</Link>
          </div>
          <Link to="/ServiceAreasPage" className="text-sm text-primary-foreground/80 hover:text-secondary flex items-center gap-1 transition-colors group">
            Need help in your area? View all service areas <ChevronRight className="size-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
        
        <p className="text-lg md:text-xl text-primary-foreground/90 font-default max-w-3xl leading-relaxed">
          We select materials engineered for decades of protection in Maryland's climate. Better protection, lower energy bills, and insurance approval.
        </p>
        
        <p className="text-base md:text-lg text-primary-foreground/80 font-default max-w-2xl">
          Most jobs completed within 3-5 business days.
        </p>

        <p className="text-sm md:text-base text-primary-foreground/70 font-default max-w-2xl italic">Financing available for qualified homeowners.&nbsp;&nbsp;</p>
        
        <div className="mt-4">
          <Button asChild size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground border-none px-8 text-base font-semibold shadow-lg rounded-md">
            <Link to="/ContactPage">
              Get Your Free Roof Assessment + Cost Estimate
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}